import {useEffect, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import {createNotification} from "app/actions/notifications";
import {get as getContributer, update as updateContributer} from "app/requests/admin/contributers";
import {Loading} from "components/pages";
import {valueFrom, valueFromTarget} from "lib/form";
import {usePrompt} from "lib/hooks";
import useAppContext from "lib/hooks/use-app-context";
import Form from "./form";

export default function AdminContributersEdit() {
  const {dispatch} = useAppContext();
  const navigate = useNavigate();
  const {id} = useParams();
  const [block, setBlock] = useState(false);
  const [changes, setChanges] = useState({});
  const [contributer, setContributer] = useState(null);

  usePrompt({when: block});
  useEffect(() => {
    getContributer(id).then((data) => setContributer(data.contributer));
  }, []);

  if(!contributer) { return <Loading />; }

  const onChange = ({target}) => {
    setBlock(true);
    setChanges({...changes, [target.name]: valueFromTarget(target)});
  };
  const onSubmit = (e) => {
    e.preventDefault();

    if(Object.keys(changes).length === 0) {
      return dispatch(createNotification({
        content: "Please make changes before submitting",
        type: "danger"
      }));
    }

    setBlock(false);
    updateContributer(contributer.id, {contributer: changes}).then((data) => {
      if(data.success) {
        navigate("/admin/contributers", {state: {message: data.message, type: "success"}});
      } else {
        dispatch(createNotification({content: data.message, type: "danger"}));
      }
    });
  };
  const value = (name, defaultValue) => valueFrom({
    defaultValue,
    name,
    objects: [changes, contributer]
  });

  return (
    <div className="container-fluid">
      <h1 className="text-center">Edit Contributer</h1>
      <Form {...{onChange, onSubmit, value}} />
    </div>
  );
}
